export const isPostSaleProfile = (autorizacoes) => Boolean(
    (autorizacoes?.includes('Relacionamento') || autorizacoes?.includes('Cobranca')) &&
    !autorizacoes?.includes('CRM') &&
    !autorizacoes?.includes('Adm')
);
